import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.10_@types+node@20.19.18_@vercel+blob@2.8.0_@vercel+functions@2.2.13_@aws-sdk+_741dc59ea912bc46bf40163e91c1c604/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.10_@types+node@20.19.18_@vercel+blob@2.8.0_@vercel+functions@2.2.13_@aws-sdk+_741dc59ea912bc46bf40163e91c1c604/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}